import {ENV} from '../config';
import {EnvConfig} from '../config/envConfig.interface';

export function getEnvConfig(): EnvConfig {
  const host = window.location.host;

  const config = ENV.find(e => e.host === host);

  if (!config) {
    throw new Error('INVALID ENVIRONMENT!');
  }

  return config;
}
